import styled from 'styled-components';

export default styled.div`
  height: 61px;
  cursor: pointer;
`;
